
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Company",
    "tableTitle": "Company List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/company/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/company`,
        edit: `${baseUrl}/api/mms/company/edit`,
        delete: `${baseUrl}/api/mms/company/remove`
    },
    "tableCol": [
        {
            name: 'Company',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Company',
                    name: 'name',
                    "required": true
                },
                {
                    "type": "file",
                    "label": "Company Logo",
                    "name": "logo"
                },
                {
                    "type": "textArea",
                    "label": "Company address",
                    "name": "address"
                }
            ]
        }
    ],
    "mockData": [{
        "company": "dgdg"
    }]
};